import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-bone pt-20 pb-10 px-6 lg:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 mb-20">
          <div>
            <p className="font-sub font-bold text-lg mb-4">
              construire<span className="text-terra">maison</span>.net
            </p>
            <p className="text-sm text-bone/60 leading-relaxed max-w-xs">
              Le guide gratuit pour construire sa maison : vidéos, simulateurs et articles pour maîtriser votre projet de A à Z.
            </p>
          </div>
          <div>
            <p className="font-sub text-xs uppercase tracking-[0.2em] text-bone/50 mb-4">Navigation</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#simulateurs" className="text-bone/70 hover:text-bone transition-colors duration-200" data-testid="footer-link-simulateurs">Simulateurs</a></li>
              <li><a href="#etapes" className="text-bone/70 hover:text-bone transition-colors duration-200" data-testid="footer-link-etapes">Les étapes clés</a></li>
              <li><a href="#guides" className="text-bone/70 hover:text-bone transition-colors duration-200" data-testid="footer-link-guides">Guides</a></li>
            </ul>
          </div>
          <div>
            <p className="font-sub text-xs uppercase tracking-[0.2em] text-bone/50 mb-4">Légal</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mentions-legales" className="text-bone/70 hover:text-bone transition-colors duration-200" data-testid="footer-link-legal">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" className="text-bone/70 hover:text-bone transition-colors duration-200" data-testid="footer-link-privacy">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <p className="font-display text-[13vw] md:text-[9vw] leading-none text-bone/10 select-none whitespace-nowrap" aria-hidden="true">
          construiremaison
        </p>
        <div className="border-t border-bone/10 mt-8 pt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-bone/50">
          <p>© 2026 Le Guide pour construire sa maison</p>
          <p>construiremaison.net</p>
        </div>
      </div>
    </footer>
  );
}
